import React, { useEffect, useState } from "react";
import {
  Avatar,
  AvatarBadge,
  Icon,
  useColorMode,
  StyleProps,
} from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import { isIconFillable } from "util/constants";
import useCustomChakraTheme from "hooks/use-custom-chakra-theme";

type ProfileAvatarProps = {
  name?: string;
  channelIcon?: string;
  profilePicture: string;
  onClick?: () => void;
  avatarStyle?: StyleProps;
};

const ProfileAvatar = ({
  channelIcon,
  name,
  profilePicture,
  onClick,
  avatarStyle,
}: ProfileAvatarProps) => {
  const { colorMode } = useColorMode();
  const { colorScheme } = useCustomChakraTheme();

  const [channelColor, setChannelColor] = useState<string>(
    colorMode === "light" ? `${colorScheme}.500` : `${colorScheme}.200`
  );

  useEffect(() => {
    setChannelColor(
      colorMode === "light" ? `${colorScheme}.500` : `${colorScheme}.200`
    );
  }, [colorMode, colorScheme]);

  return (
    <Avatar
      size="sm"
      src={profilePicture}
      name={name}
      onClick={onClick}
      {...avatarStyle}
    >
      {channelIcon && (
        <AvatarBadge
          cursor="pointer"
          boxShadow={colorMode === "dark" ? "none" : "0px -1px 5px 3px white"}
          backgroundColor={colorMode === "dark" ? "inherit" : "white"}
          border={colorMode === "dark" ? "none" : "1px solid white"}
        >
          <Icon
            as={ReactSVG}
            src={channelIcon}
            __css={{
              path: isIconFillable(channelIcon)
                ? {
                    fill: channelColor,
                  }
                : {},
            }}
          />
        </AvatarBadge>
      )}
    </Avatar>
  );
};

export default ProfileAvatar;
